import styled from 'styled-components';

export const SceneCasePage = styled.div`
  min-height: var(--page-content-height);
`;

export const TopModule = styled.div`
  height: 754px;
  margin-bottom: 200px;
  background: #f7f6f9;
  position: relative;
`;

export const ModuleContainer1 = styled.div``;

export const ModuleTitle = styled.div<{ marginBottom: number; marginTop?: number }>`
  height: 48px;
  width: 100%;
  font-size: 40px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: var(--font-weight-lg);
  color: var(--text-color-0);
  line-height: 48px;
  letter-spacing: 2px;
  margin-top: ${props => props.marginTop || 72}px;
  margin-bottom: ${props => props.marginBottom}px;
  .highlight {
    color: #4f41c7;
  }
`;
